const React = require('react');
const {UserRegistrationRouting} = require('../../../dumb/AdminHelpers/AdminUserRegistration');

const {apiAdminMerchantCompanyGet} = require("../../../../api/admin/retailersCreate");

const CompanyForm = require('./components/CompanyForm');
const ProfileForm = require('./components/ProfileForm');
const BusinessOwners = require('./components/BusinessOwners');
const ActivationScreen = require('./components/ActivationScreen');

module.exports = () => {
  return (
    <UserRegistrationRouting
      title="New Retailer"
      newUserDataGetter={apiAdminMerchantCompanyGet}
      views={{
        company: CompanyForm,
        personalProfile: ProfileForm,
        businessOwners: BusinessOwners,
        activationScreen: ActivationScreen,
      }}
    />
  )
};
